// actions
import {
  GET_FEEDS,
  ADD_FEED,
  GET_FEEDS_BY_OPERATOR,
  GET_FEEDS_BY_MANAGER,
  GET_FEEDS_BY_ADMIN,
  GET_ADDITIONAL,
  SET_FEEDS,
  UPDATE_FEEDS,
  CLEAR_FEEDS,
  SET_SEARCH,
  SET_PUBLISHED,
  SET_PAGE,
  SET_META,
  SET_CACHED_PAGES,
  SET_CACHED_PARAMS,
  SEARCH,
  DELETE_FEED,
  UNPUBLISHED_FEED,
  PUBLISHED_FEED,
  RUN_FEED,
  PAUSE_FEED,
  SET_FEED_STATUS,
} from "../../store/actions/feeds";

import { AUTH_LOGOUT } from "../../store/actions/auth";

import { SET_LOADING, CLEAR_ERROR } from "../actions/common";

// api
import {
  getThreadsApi,
  getThreadsList,
  getAdditionalInfoApi,
  threadsSaveApi,
  threadUnpublishApi,
  threadPublishApi,
  threadDeleteApi,
} from "../../api/feeds";

// functions
import searchMethods from "../../helpers/searchMethods";
import feedsMethods from "../../helpers/feedsMethods";
import searchMethodsMain from "../../helpers/searchMethodsMain";
import feedsMethodsMain from "../../helpers/feedsMethodsMain";
import sortMethods from "../../helpers/sortMethods";
import { cache } from "react";

const getFeedsByRole = (role, feeds) => {
  return feedsMethods[role](feeds, state.status.current);
};

const getFeedsByRoleMain = (role, feeds) => {
  return feedsMethodsMain[role](feeds, state.status.current);
};

const getFeedsBySearch = (role) => {
  return searchMethods[role][state.searchParams.select](state);
};

const getFeedsBySearchMain = (role) => {
  return searchMethodsMain[role][state.searchParams.select](state);
};

// store
const state = {
  roleThreads: {
    operator: GET_FEEDS_BY_OPERATOR,
    manager: GET_FEEDS_BY_MANAGER,
    admin: GET_FEEDS_BY_ADMIN,
  },
  published: true,
  page: 1,
  meta: 0,
  cachedPages:{},
  cachedParams:'',
  status: {
    current: ["pause", "run"],
    items: {
      pause: {
        name: "pause",
        title: "Остановленные",
      },
      run: {
        name: "run",
        title: "Запущенные",
      },
    },
  },
  feeds: [],
  hasSearch: false,
  searchParams: {},
};

const getters = {
  retrospective: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.retro : "";
  },
  retro_max: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.retro_max : "";
  },
  feedTitle: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.threadname : "";
  },
  feedNetworks: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.networks : "";
  },
  feedShowAtMap: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.show_at_map : false;
  },
  feedUid: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.uid : "";
  },
  feedUsername: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.username : "";
  },
  feedIsStrict: (state) => (threadId) => {
    const feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed.is_strict : false;
  },
  feed: (state) => (threadId) => {
    let feed = state.feeds.find((feed) => feed.id === threadId);
    return feed ? feed : null;
  },
  feedStatus: (state) => state.status.current,
  feedStatusItems: (state) => state.status.items,
  allFeeds: (state) => state.feeds,
  mainFeeds: (state, getters) => {
    let sortedFeeds = sortMethods.sortFeeds(
      JSON.parse(JSON.stringify(state.feeds)),
    );

    return getFeedsByRoleMain(getters.userRole, sortedFeeds);
  },
  feeds: (state, getters) => {
    let sortedFeeds = sortMethods.sortFeeds(
      JSON.parse(JSON.stringify(state.feeds)),
    );

    return getFeedsByRole(getters.userRole, sortedFeeds);
  },
  feedsCount: (state) => state.feeds.length,
  hasSearch: (state) => state.hasSearch,
  searchString: (state) => (state.hasSearch ? state.searchParams.input : ""),
  published: (state) => state.published,
  page: (state) => state.page,
  meta: (state) => state.meta,
  cachedPages: (state) => state.cachedPages,
  cachedParams: (state) => state.cachedParams,
};

const actions = {
  [GET_FEEDS]: ({ state, getters, dispatch }, params) => {
    console.log("aaaa", state.cachedPages)
    dispatch(state.roleThreads[getters.userRole], {
      filter: {
        publication_status: getters.published ? "published" : "unpublished",
        status:
          getters.feedStatus.length == 1
            ? getters.feedStatus[0] == "run"
              ? 1
              : 0
            : null,
        id:
          state.searchParams.select == "byNumber"
            ? state.searchParams.input
            : "",
        user_name:
          state.searchParams.select == "byUser" ? state.searchParams.input : "",
        title:
          state.searchParams.select == "byName" ? state.searchParams.input : "",
      },
      start: getters.page * 10 - 10,
      limit: getters.listView && getters.meta > 0 ? getters.meta : 10,
      cachedPages: state.cachedPages,
      cachedParams: state.cachedParams
    });
  },
  [GET_FEEDS_BY_OPERATOR]: ({ commit }, params) => {
    commit(CLEAR_ERROR);
    commit(CLEAR_FEEDS);
    commit(SET_LOADING, true);
    commit(SET_CACHED_PARAMS, params.start+JSON.stringify(params.filter)+params.limit)
    if (params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit]) {
      commit(SET_LOADING, false);
      commit(SET_FEEDS, [...params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].items]);
      commit(SET_META, params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].meta.count);
    }
    else
    getThreadsApi({ filter: params.filter, limit: params.limit, start: params.start })
      .then((resp) => {
        commit(SET_LOADING, false);
        commit(SET_FEEDS, [...resp.data.items]);
        commit(SET_CACHED_PAGES, resp.data)
        commit(SET_META, resp.data.meta.count);
      })
      .catch((e) => {
        if (e.response.status === 403) {
          commit(AUTH_LOGOUT);
        }
      });
  },
  [GET_FEEDS_BY_MANAGER]: ({ commit }, params) => {
    commit(CLEAR_ERROR);
    commit(CLEAR_FEEDS);
    commit(SET_LOADING, true);
    commit(SET_CACHED_PARAMS, params.start+JSON.stringify(params.filter)+params.limit)
    if (params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit]) {
      commit(SET_LOADING, false);
      commit(SET_FEEDS, [...params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].items]);
      commit(SET_META, params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].meta.count);
    }
    else
    getThreadsApi({ filter: params.filter, limit: params.limit, start: params.start })
      .then((resp) => {
        commit(SET_LOADING, false);
        commit(SET_FEEDS, [...resp.data.items]);
        commit(SET_CACHED_PAGES, resp.data)
        commit(SET_META, resp.data.meta.count);
      })
      .catch((e) => {
        if (e.response.status === 403) {
          commit(AUTH_LOGOUT);
        }
      });
  },
  [GET_FEEDS_BY_ADMIN]: ({ commit }, params) => {
    commit(CLEAR_ERROR);
    commit(CLEAR_FEEDS);
    commit(SET_LOADING, true);
    commit(SET_CACHED_PARAMS, params.start+JSON.stringify(params.filter)+params.limit)
    if (params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit]) {
      commit(SET_LOADING, false);
      commit(SET_FEEDS, [...params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].items]);
      commit(SET_META, params.cachedPages[params.start+JSON.stringify(params.filter)+params.limit].meta.count);
    }
    else
    getThreadsApi({ filter: params.filter, limit: params.limit, start: params.start })
      .then((resp) => {
        commit(SET_LOADING, false);
        commit(SET_FEEDS, [...resp.data.items]);
        commit(SET_CACHED_PAGES, resp.data)
        commit(SET_META, resp.data.meta.count);
      })
      .catch((e) => {
        if (e.response.status === 403) {
          commit(AUTH_LOGOUT);
        }
      });
  },
  [GET_ADDITIONAL]: ({ commit }, payload) => {
    if (!state.cachedPages[state.cachedParams].items.find((item) => item.id == payload[0].id).additional)
    return Promise.all(
      payload.map(async (item) =>
        getAdditionalInfoApi({ thread_id: item.id }).then((infoResp) => {
          return { ...item, additional: infoResp.data };
        }),
      ),
    ).then((data) => {
      commit(UPDATE_FEEDS, data);
    });
  },
  [SET_SEARCH]: ({ commit }, payload) => {
    commit(SET_SEARCH, payload);
    commit(SET_PAGE, 1);
  },
  [SET_PUBLISHED]: ({ commit }, payload) => {
    commit(SET_PUBLISHED, payload);
    commit(SET_PAGE, 1);
  },
  [SET_PAGE]: ({ commit }, payload) => {
    commit(SET_PAGE, payload);
  },
  [SEARCH]: ({ commit }, payload) => {
    commit(SEARCH, payload);
  },
  [ADD_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadsSaveApi({ id: 0, ...params })
        .then((resp) => {
          commit(ADD_FEED, resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [CLEAR_FEEDS]: ({ commit }) => {
    commit(CLEAR_FEEDS);
  },
  [DELETE_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadDeleteApi(params)
        .then((resp) => {
          commit(DELETE_FEED, params.id);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [UNPUBLISHED_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadUnpublishApi(params)
        .then((resp) => {
          commit(UNPUBLISHED_FEED, params.id);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [PUBLISHED_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadPublishApi(params)
        .then((resp) => {
          commit(PUBLISHED_FEED, params.id);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [RUN_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadsSaveApi(params)
        .then((resp) => {
          commit(RUN_FEED, params.id);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [PAUSE_FEED]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      threadsSaveApi(params)
        .then((resp) => {
          commit(PAUSE_FEED, params.id);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    }),
  [SET_FEED_STATUS]: ({ commit }, payload) => {
    commit(SET_FEED_STATUS, payload);
  },
};

const mutations = {
  [RUN_FEED]: (state, id) => {
    state.feeds = state.feeds.map((item) => {
      if (item.id === id) {
        item.status = "play";
      }
      return item;
    });
  },
  [PAUSE_FEED]: (state, id) => {
    state.feeds = state.feeds.map((item) => {
      if (item.id === id) {
        item.status = "pause";
      }
      return item;
    });
  },
  [ADD_FEED]: (state, feed) => {
    state.feeds.push(feed);
  },
  [DELETE_FEED]: (state, id) => {
    state.feeds = state.feeds.filter((item) => Number(item.id) !== Number(id));
  },
  [UNPUBLISHED_FEED]: (state, id) => {
    state.feeds = state.feeds.filter((item) => Number(item.id) !== Number(id));
  },
  [PUBLISHED_FEED]: (state, id) => {
    state.feeds = state.feeds.filter((item) => Number(item.id) !== Number(id));
  },
  [SET_FEEDS]: (state, payload) => {
    state.feeds = payload;
  },
  [SET_PUBLISHED]: (state, payload) => {
    state.published = payload;
  },
  [SET_PAGE]: (state, payload) => {
    state.page = payload;
  },
  [SET_META]: (state, payload) => {
    state.meta = payload;
  },
  [SET_CACHED_PAGES]: (state, payload) => {
    state.cachedPages[payload.meta.start + JSON.stringify(payload.meta.filter)+payload.meta.limit] = payload;
  },
  [SET_CACHED_PARAMS]: (state, payload) => {
    state.cachedParams = payload;
  },
  [SET_SEARCH]: (state, payload) => {
    state.hasSearch = payload;
  },
  [SEARCH]: (state, payload) => {
    state.searchParams = { ...payload };
  },
  [CLEAR_FEEDS]: (state) => {
    state.feeds = [];
  },
  [UPDATE_FEEDS]: (state, payload) => {
    state.cachedPages[state.cachedParams].items = state.cachedPages[state.cachedParams].items.map((item) => {
      payload.forEach((feedItem) => {
        if (item.id === feedItem.id) {
          item = { ...item, ...feedItem };
        }
      });

      return item;
    });
    state.feeds = state.feeds.map((item) => {
      payload.forEach((feedItem) => {
        if (item.id === feedItem.id) {
          item = { ...item, ...feedItem };
        }
      });

      return item;
    });
  },
  [SET_FEED_STATUS]: (state, payload) => {
    state.status.current = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
